import { useEffect, useState } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

interface EditorProps {
  initialValue?: string;
  onChange: (content: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

export function Editor({
  initialValue = "",
  onChange,
  placeholder,
  disabled = false,
}: EditorProps) {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleChange = (content: string) => {
    setValue(content);
    onChange(content);
  };

  const modules = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ header: 1 }, { header: 2 }],
      ["link"],
    ],
  };

  const formats = ["bold", "italic", "underline", "header", "link"];

  return (
    <div className="quill-editor">
      <ReactQuill
        theme="snow"
        value={value}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        readOnly={disabled}
      />
    </div>
  );
}
